import $ from 'jquery';
import * as React from 'react';
import { useEffect, useMemo, useRef, useState } from 'react';
import SearchForm from '../../../../new_design/common/search_widget/search_form/common';
import { SearchDataContext } from '../../lib/search_data_context';
import { DatesPicker } from '../dates_picker/search_data_popup.dates_picker.js';
import { GuestsPicker } from '../guests_picker';

const SEARCH_DATA_POPUP_ID = 'search-data-popup';
const TITLE_REDUNDANT = ' на карте';

/**
 * @param {string} title
 * @param {boolean} mapOpened
 * @param {(function(dateStart: string, dateEnd: string, countGuests: number, childrenAges: Array<number>, withPet: boolean): void) | undefined} onSubmit
 * @constructor
 */
export const SearchDataPopup = ({ title, mapOpened, onSubmit }) => {
  const [dateStart, setDateStart] = useState();
  const [dateEnd, setDateEnd] = useState();
  const [countGuests, setCountGuests] = useState();
  const [childrenAges, setChildrenAges] = useState();
  const [withPet, setWithPet] = useState();

  const [show, setShow] = useState(false);

  const overlayRef = useRef(null);
  const popupRef = useRef(null);

  const popupTitle = useMemo(() => {
    if (!title.endsWith(TITLE_REDUNDANT)) return title;
    return title.slice(0, -TITLE_REDUNDANT.length);
  }, [title]);

  const handleClosePopup = () => {
    overlayRef.current?.fadeOut();
    $(popupRef.current).fadeOut();
  };

  const openPopup = () => {
    overlayRef.current?.fadeIn();
    $(popupRef.current).fadeIn();
  };

  const handleChangeDates = (newDateStart, newDateEnd) => {
    setDateStart(newDateStart);
    setDateEnd(newDateEnd);
  };

  const handleSubmit = () => {
    handleClosePopup();
    setShow(false);
    onSubmit?.(dateStart, dateEnd, countGuests, childrenAges, withPet);
  };

  useEffect(() => {
    SearchForm.getSearchData().then(({ date_start, date_end }) => {
      if (!!date_start || !!date_end) return;

      setShow(true);
    });
  }, []);

  // Инициализация элементов модального окна
  useEffect(() => {
    if (show) {
      overlayRef.current = $('.overlay');
    }
  }, [show]);

  useEffect(() => {
    if (show && mapOpened) {
      openPopup();
    }
  }, [show, mapOpened]);

  if (!show) return;
  return (
    <SearchDataContext.Provider
      value={{
        countGuests,
        childrenAges,
        withPet,
        onChangeDates: handleChangeDates,
        onChangeCountGuests: setCountGuests,
        onChangeChildrenAges: setChildrenAges,
        onChangeWithPet: setWithPet,
      }}
    >
      <div
        className='popup-select popup-select-absolute popup search-data-popup'
        id={SEARCH_DATA_POPUP_ID}
        ref={popupRef}
      >
        <div className='fake-overlay'></div>
        <div className='search-data-popup__nav-bar'>
          <div className='search-data-popup__title'>{popupTitle}</div>
          <a className='search-data-popup__close icon-close popup-close' onClick={handleClosePopup}></a>
        </div>
        <div className='search-data-popup__form-wrapper' id={`${SEARCH_DATA_POPUP_ID}-form`}>
          <div className='search-data-popup__form-title'>Выберите даты поездки</div>
          <div className='search-data-popup__form-container'>
            <div className='search-data-popup__inputs-container'>
              <DatesPicker formId={SEARCH_DATA_POPUP_ID} />
              <GuestsPicker formId={SEARCH_DATA_POPUP_ID} />
            </div>
            <a
              className={'button button_size_large button_variant_filled button_color_primary button_type_label-only'}
              onClick={handleSubmit}
            >
              Найти
            </a>
          </div>
        </div>
      </div>
    </SearchDataContext.Provider>
  );
};
